module.exports = __webpack_public_path__ + "img/order_sorting.3d27894.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/order_sorting.svg
// module id = Wd+y
// module chunks = 1